module.exports = __webpack_public_path__ + "img/fail.c14d5199.svg";